// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createTask,
  deleteTask,
  getTaskList,
  getTaskDetail,
  updateTask,
  changeStatusTask,
  createTaskInJob,
  editTaskInJob,
} from '~/thunks/task/taskThunk';

export interface ITaskState {
  isRefreshTaskList: boolean;
}

export const initialState: ITaskState = {
  isRefreshTaskList: false,
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setRefreshTaskList(state, action) {
      state.isRefreshTaskList = action.payload;
    },
  },
  extraReducers(builder) {
    // POST: Create task
    builder
      .addCase(createTask.pending, (_state) => {})
      .addCase(createTask.fulfilled, (_state) => {})
      .addCase(createTask.rejected, (_state) => {});

    // GET: Get task list
    builder
      .addCase(getTaskList.pending, (_state) => {})
      .addCase(getTaskList.fulfilled, (_state) => {})
      .addCase(getTaskList.rejected, (_state) => {});

    // DELETE: Delete Task
    builder
      .addCase(deleteTask.pending, (_state) => {})
      .addCase(deleteTask.fulfilled, (_state) => {})
      .addCase(deleteTask.rejected, (_state) => {});

    // GET: Get task detail
    builder
      .addCase(getTaskDetail.pending, (_state) => {})
      .addCase(getTaskDetail.fulfilled, (_state) => {})
      .addCase(getTaskDetail.rejected, (_state) => {});

    // PUT: Update task
    builder
      .addCase(updateTask.pending, (_state) => {})
      .addCase(updateTask.fulfilled, (_state) => {})
      .addCase(updateTask.rejected, (_state) => {});

    // PUT: Change status task
    builder
      .addCase(changeStatusTask.pending, (_state) => {})
      .addCase(changeStatusTask.fulfilled, (_state) => {})
      .addCase(changeStatusTask.rejected, (_state) => {});

    // POST: Create task in detail job
    builder
      .addCase(createTaskInJob.pending, (_state) => {})
      .addCase(createTaskInJob.fulfilled, (_state) => {})
      .addCase(createTaskInJob.rejected, (_state) => {});

    // PUT: Edit task in detail job
    builder
      .addCase(editTaskInJob.pending, (_state) => {})
      .addCase(editTaskInJob.fulfilled, (_state) => {})
      .addCase(editTaskInJob.rejected, (_state) => {});
  },
});

// Action
export const taskActions = taskSlice.actions;

// Selectors
export const selectIsRefreshTaskList = (state: RootState) => state.task.isRefreshTaskList;

// Reducer
const taskReducer = taskSlice.reducer;
export default taskReducer;
